import * as z from "zod"
import { stringRequired } from "@/models/common"
import { DiagnosisCode } from "@/modules/admin/treatment/components/sections/diagnosis/diagnosis-drawer"
import { Country } from "@/types/__generated__/union-types"

export const treatmentFormSchema = z.object({
  id: z.string().optional(),
  name: stringRequired.max(100, { message: "common.fieldErrorList.maxLengthField" }),
  countries: z
    .array(z.custom<Country>(), { error: "common.fieldErrorList.requiredField" })
    .min(1, { message: "common.fieldErrorList.requiredField" }),
  germanTitle: stringRequired.max(50, { message: "common.fieldErrorList.maxLengthField" }),
  frenchTitle: stringRequired.max(50, { message: "common.fieldErrorList.maxLengthField" }),
  englishTitle: stringRequired.max(50, { message: "common.fieldErrorList.maxLengthField" }),
  italianTitle: stringRequired.max(50, { message: "common.fieldErrorList.maxLengthField" }),
  germanSynonyms: z.string().optional(),
  frenchSynonyms: z.string().optional(),
  englishSynonyms: z.string().optional(),
  italianSynonyms: z.string().optional(),
  germanRecommended: z.string().optional(),
  frenchRecommended: z.string().optional(),
  englishRecommended: z.string().optional(),
  italianRecommended: z.string().optional(),
  germanInstruction: z.string().optional(),
  frenchInstruction: z.string().optional(),
  englishInstruction: z.string().optional(),
  italianInstruction: z.string().optional(),
  diagnosisCodes: z.array(z.custom<DiagnosisCode>()).optional(),
})

export type TreatmentForm = z.infer<typeof treatmentFormSchema>
